/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import React from "react";
import { Helmet } from "react-helmet";
import { t } from "./i18n/i18n";
import { Subscribe } from "unstated";
import { Switch } from "react-router";
import { AppState } from "app-state/AppState";
import Header from "components/base/Header/Header";
import Footer from "components/base/Footer/Footer";
import ErrorRoutes from "routes/ErrorRoutes";
import AppRoute from "./routes/AppRoute";
import { isInLauncher } from "./launcher-bindings/launcherWebviewClient";
import { GoogleTagManagerInit } from "components/gtmInit";

import "./styles";
import { globalVar, isProduction } from "utils/globalVar";

// SA-61 Implement zendesk support: start
let launcherTimeOut: NodeJS.Timeout;
// SA-61 Implement zendesk support: end

export default class App extends React.Component {
  componentDidMount(): void {
    import("./app-tasks")
      .then((module) => module.default)
      .then((taskRunner) => taskRunner());

      this.onIframeLoad();
  }

  // SA-61 Implement zendesk support: start
  isIFrame(checkDom: HTMLElement | null): checkDom is HTMLIFrameElement {
    return checkDom !== null && checkDom.tagName === "IFRAME";
  }

  onIframeLoad() {
    launcherTimeOut = setInterval(() => {
      const launcher = document.getElementById("launcher");

      if (launcher !== null) {
        if (this.isIFrame(launcher) && launcher.contentWindow) {
          if (launcher.contentWindow.document.getElementsByTagName("span")[1]) {
            if(launcher.contentWindow.document.getElementsByTagName("span")[1].clientWidth > 0) {
              launcher.classList.add("zendesk-desktop-style");
              // SA-73 back to top button overlap : start
              document.body.classList.add("zendesk-desktop-style");
              // SA-73 back to top button overlap : end
            }

            launcher.contentWindow.document.getElementsByTagName("span")[1].innerText = t(
              "Starbreeze.zendesk.button.text"
            );
            clearTimeout(launcherTimeOut);
          }
        }
      }
    }, 100);
  };
  // SA-61 Implement zendesk support: end

  render() {
    return (
      <Subscribe to={[AppState]}>
        {(appState: AppState) => {
          const {
            state: { appHistory },
          } = appState;
          return (
            <div key={appHistory.location.pathname} id="app">
              {process.env.NODE_ENV !== "development" && <GoogleTagManagerInit />}
              <Helmet defaultTitle={t("Starbreeze.Common.appName")}>
                <meta charSet="utf-8" />
                <meta name="description" content={t("Starbreeze.Common.defaultMetaDescription")} />

                {/* // SA-61 Implement zendesk support: start */}
                {globalVar.STARBREEZE_ZENDESK_KEY !== "" && (
                  <script
                    type="text/javascript"
                    crossOrigin="true"
                    id="ze-snippet"
                    src={`https://static.zdassets.com/ekr/snippet.js?key=${globalVar.STARBREEZE_ZENDESK_KEY}`}
                  ></script>
                )}
                {/* // SA-61 Implement zendesk support: end */}
              </Helmet>
              {!isInLauncher() && isProduction && <GoogleTagManagerInit />}
              {!isInLauncher() && <Header />}
              <div className="container">
                <Switch>
                  {AppRoute()}
                  {ErrorRoutes()}
                </Switch>
              </div>
              {!isInLauncher() && <Footer />}
            </div>
          );
        }}
      </Subscribe>
    );
  }
}
